import React, { Component } from 'react'
import classNames from 'classnames'
import CSSModules from 'react-css-modules'

import PropTypes from 'prop-types'

import styles from './iframe.scss'
import Loading from 'components/loading'

class Iframe extends Component {

	constructor() {
		super()

		this.state = {
			hasLoaded: false,
		}
	}

	render() {

		const handleIframeLoad = () => {
			this.setState({
				hasLoaded: true,
			})
		}

		return (
			<div styleName={
				classNames({
					autoSize: true,
					'autoSize--loading': !(this.state.hasLoaded),
				})
			}>
				<div styleName='loading' style={{display: this.state.hasLoaded?'none':'block'}}>
					<Loading />
				</div>
				<iframe
					src={this.props.src}
					frameBorder='0'
					allowFullScreen={true}
					allow={`microphone; camera ${this.props.autoplay ? '; autoplay' : ''}`}
					onLoad={handleIframeLoad}
					style={
						{
							display: this.state.hasLoaded?'block':'none',
							width: '100%',
							height: '100%',
						}
					}
				></iframe>
			</div>
		)
	}

}

Iframe.propTypes = {
	src: PropTypes.string,
	autoplay: PropTypes.bool,
}

Iframe.defaultProps = {
	autoplay: false,
}

export default CSSModules(Iframe, styles, {allowMultiple: true})
